import { useAuthenticator } from "@aws-amplify/ui-react";
import { useRouter } from "next/router";
import { useEffect } from "react";

import { useUserFetchInitially } from "@/hooks/useUsers";
import useAuthStore from "@/store/useAuthStore";
import { PAGE_URL } from "@/utils/constants";
import { getFromLocalStorage, indexedDbStorage } from "@/utils/indexDBStorage";

const AuthListener = () => {
  // use get profile initially
  const { fetchUser } = useUserFetchInitially();
  const router = useRouter();
  const { route } = useAuthenticator();

  useEffect(() => {
    (async () => {
      if (route === "authenticated") {
        await fetchUser();
      }

      const token = await getFromLocalStorage("token");
      if (route === "idle") {
        if (!token) {
          router.replace({ pathname: PAGE_URL.login });
          return;
        }
      }

      if (route === "signOut") {
        indexedDbStorage.removeItem("token");
        useAuthStore.setState((prev) => ({
          ...prev,
          user: {
            profile: null,
            token: "",
            bio: null,
          },
          isAuthenticated: false,
        }));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, router, router.pathname]);

  return null;
};

export default AuthListener;
